import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../store";
import { Button, Grid, IconButton, Menu, MenuItem, Typography, useMediaQuery, useTheme } from "@mui/material";
import {
	setCurrentGroupIndex,
	setCurrentTabIndex,
	setGoBack,
} from "../../store/Navigation/NavSlice";
import { setCurrentSection } from "../../store/User/UserSlice";
import { useEffect, useState } from "react";
import { FormattedPhrase } from "../../context/FormattedPhrase";
import MenuIcon from '@mui/icons-material/Menu';

const TabGroup: React.FC = () => {
	const { currentSection, localSurveyLanguage } = useSelector((state: RootState) => state.user);
	const { mainTabGroup } = useSelector((state: RootState) => state.navigation);
	const [selectedIndex, setSelectedIndex] = useState<number>(0);
	const [index, setIndex] = useState<number>(0);
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const [menuPosition, setMenuPosition] = useState<any>();

	const handleMenuOpen = (event) => {
	setMenuPosition({
		top: event.currentTarget.getBoundingClientRect().bottom,
		left: window.innerWidth / 2,
	});
	};

	const handleMenuClose = () => setMenuPosition(null);

	const dispatch = useDispatch();


	useEffect(() => {
		if (currentSection && mainTabGroup) {
			let currentIndex = mainTabGroup.findIndex((x) => {
				return x.sectionId == currentSection.sectionId;
			});
			setIndex(currentIndex);
			if (index < currentIndex) {
				setSelectedIndex(currentIndex);
			}
		}
	}, [currentSection, index, selectedIndex]);

	const changeSection = (x, i) => {
		dispatch(setGoBack(true));
		window.scrollTo(0, 0);
		dispatch(setCurrentSection(x));
		dispatch(setCurrentGroupIndex(-1));
		dispatch(setCurrentTabIndex(-1));

		if (selectedIndex < i) {
			setSelectedIndex(selectedIndex + 1);
			setIndex(index + 1);
		}
	};

	return (
		<Grid container direction="row" alignSelf="center" justifyContent="center">
			{isMobile ? (
				<Grid
					container
					item
					xs={12}
					justifyContent="center"
					alignItems="center"
					sx={{ gap: 1 }}
				>
					<Button
						className="tab-group tab-border"
						sx={{
							backgroundColor: theme.palette.secondary.light,
							"&:hover": {
								backgroundColor: theme.palette.secondary.light,
								borderRadius: "5px",
							},
						}}
						variant="text"
						onClick={() =>
							changeSection(
								currentSection,
								mainTabGroup.findIndex(
									(i) => i.sectionId === currentSection.sectionId
								)
							)
						}
					>
						<Typography
							sx={{
								fontWeight: "bold",
								color: theme.palette.text.primary,
							}}
							variant="caption"
						>
							{currentSection.component?.includes(
								"SurveyReviewQuestionsComponent"
							)
								? currentSection.heading || (
									<FormattedPhrase
										id="navigation.review"
										language={localSurveyLanguage}
									/>
								)
								: currentSection.heading}
						</Typography>
					</Button>

					<IconButton onClick={handleMenuOpen} sx={{ alignSelf: "center" }}>
						<MenuIcon />
					</IconButton>

					<Menu
						open={Boolean(menuPosition)}
						onClose={handleMenuClose}
						anchorReference="anchorPosition"
						anchorPosition={menuPosition}
						transformOrigin={{ vertical: "top", horizontal: "center" }}
						PaperProps={{
							sx: {
								mt: 1,
								boxShadow:
									"0px 8px 24px rgba(0,0,0,0.25), 0px 12px 28px rgba(0,0,0,0.22)",
								borderRadius: 2,
								px: 1,
								maxHeight: "none !important",
								overflow: "visible !important",
								},
							}}
							MenuListProps={{
								disablePadding: true,
								sx: {
								maxHeight: "none !important",
								overflow: "visible !important",
								},
							}}
						>
						{mainTabGroup.map((item, index) => (
							<MenuItem
								key={index}
								onClick={() => {
									changeSection(item, index);
									handleMenuClose();
								}}
								sx={{ justifyContent: "center", mb: -1 }}
								>
								<Typography
									sx={{
									textAlign: "center",
									width: "100%",
									fontWeight:
										currentSection.sectionId === item.sectionId ? "bold" : 500,
									color: theme.palette.text.primary,
									}}
									variant="caption"
								>
									{item.component?.includes("SurveyReviewQuestionsComponent")
									? item.heading || (
										<FormattedPhrase
											id="navigation.review"
											language={localSurveyLanguage}
										/>
										)
									: item.heading}
								</Typography>
							</MenuItem>
						))}
					</Menu>
				</Grid>
			) : (
				mainTabGroup.map((item, index) => (
					<Button
						key={index}
						className={
							currentSection.sectionId === item.sectionId
								? "tab-group tab-border"
								: "tab-group"
						}
						sx={{
							backgroundColor: theme.palette.secondary.light,
							"&:hover": {
								backgroundColor: theme.palette.secondary.light,
								borderRadius: "5px",
							},
						}}
						variant="text"
						onClick={() => changeSection(item, index)}
					>
						<Typography
							sx={{
								fontWeight:
									currentSection.sectionId === item.sectionId ? "bold" : 500,
								color: theme.palette.text.primary,
							}}
							variant="caption"
						>
							{item.component?.includes("SurveyReviewQuestionsComponent")
								? item.heading || (
									<FormattedPhrase
										id="navigation.review"
										language={localSurveyLanguage}
									/>
								)
								: item.heading}
						</Typography>
					</Button>
				))
			)}
		</Grid>
	);
};

export default TabGroup;
